<template>
  <div style="width:100%; m-0 p-0">
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div
      class="row"
      align-h="start"
      v-else-if="sessions.length >= 1 && !this.errormessage"
    >
      <div class="col-12 text-right">
        <p-button
          type="info"
          class="mr-2"
          @click="printReport"
        >
          Print Directions
        </p-button>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <card>
          <div class="card-title text-center">
            <h5>{{ $root.courseName }}</h5>
          </div>
          <div class="category-title">
            {{ courseInfoSubtitle }}
          </div>
          <h6 class="text-center">
            {{ sessionDateString(0) }}
          </h6>
          <div class="address text-danger mb-3">
            <div><strong>{{ sessions[0].Location.LocationName }}</strong></div>
            <div>{{ sessions[0].Location.StreetAddress1 }}</div>
            <div v-if="sessions[0].Location.StreetAddress2">
              {{ sessions[0].Location.StreetAddress2 }}
            </div>
            <div>{{ sessions[0].Location.City }} {{ sessions[0].Location.State }}  {{ sessions[0].Location.ZipCode }}</div>
          </div>
          <div class="row mb-3">
            <div class="col-6">
              Arrival Time<br>Departure Time
            </div>
            <div class="col-6">
              7:00 am<br>4:30 pm
            </div>
          </div>
          <p
            class="description text-center"
            v-html="sessions[0].Instructions"
          />
          <div
            v-if="sessions.length === 2"
            class="category-title"
          >
            Weekend #2
          </div>
          <h6
            v-if="sessions.length === 2"
            class="text-center"
          >
            {{ sessionDateString(1) }}
          </h6>
          <div
            class="address text-danger mb-3"
            v-if="sessions.length === 2"
          >
            <div><strong>{{ sessions[1].Location.LocationName }}</strong></div>
            <div>{{ sessions[1].Location.StreetAddress1 }}</div>
            <div v-if="sessions[1].Location.StreetAddress2">
              {{ sessions[1].Location.StreetAddress2 }}
            </div>
            <div>{{ sessions[1].Location.City }} {{ sessions[1].Location.State }}  {{ sessions[1].Location.ZipCode }}</div>
          </div>
          <div
            v-if="sessions.length === 2"
            class="row mb-3"
          >
            <div class="col-6">
              Arrival Time<br>Departure Time
            </div>
            <div class="col-6">
              7:00 am<br>4:30 pm
            </div>
          </div>
          <p
            class="description text-center"
            v-if="sessions.length === 2"
            v-html="sessions[1].Instructions"
          />
        </card>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <card>
          <div class="image mb-2">
            <div
              v-if="sessions[0].Location.GoogleMapUrl"
              v-html="sessions[0].Location.GoogleMapUrl"
            />
            <i
              v-else
              class="nc-icon nc-user-run"
            />
          </div>
          <h6>Directions</h6>
          <div v-html="sessions[0].Location.Directions" />
          <div
            class="image mb-2"
            v-if="sessions.length > 1 && sessions[0].LocationId !== sessions[1].LocationId"
          >
            <div
              v-if="sessions[1].Location.GoogleMapUrl"
              v-html="sessions[1].Location.GoogleMapUrl"
            />
            <i
              v-else
              class="nc-icon nc-user-run"
            />
          </div>
          <h6 v-if="sessions.length > 1 && sessions[0].LocationId !== sessions[1].LocationId">
            Directions
          </h6>
          <div
            v-if="sessions.length > 1 && sessions[0].LocationId !== sessions[1].LocationId"
            v-html="sessions[1].Location.Directions"
          />
        </card>
      </div>
    </div>
    <course-session-print
      :sessions="sessions"
      v-show="showPrint"
    />
  </div>
</template>

<script>
import CourseSessionPrint from '@/components/course/course-session-print.vue'
import sessionApi from '@/services/api/session'
import oops from '@/components/_main/oops.vue'
import dayjs from 'dayjs'

export default {
  name: 'CourseLogistics',
  components: {
    oops,
    CourseSessionPrint
  },
  data: function () {
    return {
      sessions: null,
      loading: true,
      errormessage: null,
      showPrint: false,
      printItem: '',
      printOptions: {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/course-session.css'
        ]
      }
    }
  },
  computed: {
    courseInfoSubtitle: function () {
      if (this.sessions.length === 1) {
        return this.sessions[0].SessionName
      } else if (this.sessions.length === 2) {
        if (this.sessions[0].LocationId === this.sessions[1].LocationId) {
          return 'Weekends #1 & #2'
        } else {
          return this.sessions[0].SessionName
        }
      } else {
        return ''
      }
    }
  },
  mounted () {
    sessionApi.get(this.$root.courseKey)
      .then(response => {
        this.sessions = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    sessionDateString: function (index) {
      const st = new Date(this.sessions[index].StartDate)
      const ed = new Date(this.sessions[index].EndDate)
      const returnValue = dayjs(st).format('MMM D') + ' - ' + dayjs(ed).format('MMM D, YYYY')
      return returnValue
    },
    printReport: function () {
      this.printItem = 'printLogistics'
      this.$nextTick(function () {
        if (this.printItem !== '') {
          this.$htmlToPaper(this.printItem, this.printOptions)
          // HtmlToPaperTest.show(this.printItem, this.printOptions)
        }
        this.printItem = ''
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  i{
    height: 100px;
    position: relative;
    margin-left: 35%;
    margin-top: 10%;
    font-size: 8em;
  }
  .image {
    border: 1px solid black;
  }
  .address {
    line-height: 1;
  }
</style>
